import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";

export default function ListGallery() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: t('Dashboard'),
            url: '/dashboard'
        },
        {
            name: t('Feature'),
            url: '/dashboard/Feature'
        },
        {
            name: t('Menus List'),
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState<any>(1);

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6" dir={t("dir")}>
            <div className="max-w-7xl mx-auto">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name={t("Menu Groups")}></HeaderOfPage>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-6">
                    <div className="lg:col-span-1">
                        <NewBlogCategory reloaditem={reloadgame}></NewBlogCategory>
                    </div>
                    <div className="lg:col-span-3">
                        <ListofBlog key={key}></ListofBlog>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ListofBlog() {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);

    const getalldata = async () => {
        setError(null);
        setLoading(true);
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/menus',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setList(res.data.message);
        } catch (error: any) {
            setError(error.response?.data?.message || t('Error loading data'));
        } finally {
            setLoading(false);
        }
    }
    
    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this Group!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!"),
            cancelButtonText: t('Cancel'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/menus/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })
                    Swal.fire({
                        title: t('Saved successfully'),
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false,
                    });
                    getalldata();
                } catch (error) {
                    Swal.fire({
                        title: t('Can not be to deleted, this item have submenu'),
                        icon: 'error',
                    });
                }
            }
        });
    }
    
    useEffect(() => {
        getalldata();
    }, []);

    if (loading) {
        return (
            <div className="bg-white rounded-xl shadow-sm p-12 text-center">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <p className="mt-4 text-gray-600">{t('Loading...')}</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
                <p className="text-red-600">{error}</p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                        <tr>
                            <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                {t('Name')}
                            </th>
                            <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                {t('SLUG')}
                            </th>
                            <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                {t('Action')}
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {list != null && list.length > 0 ? (
                            list.map((item: any) => {
                                // Handle multilingual display - show name and url based on current language or fallback
                                const displayName = typeof item.name === 'object' 
                                    ? (item.name.en || item.name.ku || item.name.fa || item.name.ar || item.name.tr || '') 
                                    : (item.name || '');
                                const displayUrl = typeof item.url === 'object' 
                                    ? (item.url.en || item.url.ku || item.url.fa || item.url.ar || item.url.tr || '') 
                                    : (item.url || '');
                                
                                return (
                                <tr key={item.id || item._id} className="hover:bg-gray-50 transition-colors">
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm font-medium text-gray-900">{displayName}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm text-gray-600 font-mono">{displayUrl}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-center">
                                        <div className="flex items-center justify-center gap-2">
                                            <a
                                                href={`/dashboard/Feature/Menus/${item.id || item._id}`}
                                                className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors"
                                                title={t('Edit')}
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                </svg>
                                            </a>
                                            <button
                                                onClick={(e) => { deleted(item.id || item._id) }}
                                                className="p-2 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-lg transition-colors"
                                                title={t('Delete')}
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={3} className="px-6 py-12 text-center">
                                    <div className="text-gray-500">
                                        <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                        </svg>
                                        <p className="mt-2 text-sm">{t('No menus found')}</p>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

function NewBlogCategory({ reloaditem }: any) {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [activeLang, setActiveLang] = useState<string>('en');
    const languages = [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];
    const [data, setData] = useState<any>({
        name: { ku: '', fa: '', en: '', ar: '', tr: '' },
        url: { ku: '', fa: '', en: '', ar: '', tr: '' },
        code: '',
        keywords: { ku: '', fa: '', en: '', ar: '', tr: '' },
        description: { ku: '', fa: '', en: '', ar: '', tr: '' },
        parent: null
    });
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const [saving, setSaving] = useState<boolean>(false);

    // Handle name change with auto-slug generation for current language
    const handleNameChange = useCallback((nameValue: string) => {
        const slugValue = String(changeUrl(nameValue));
        setData((prevData: any) => ({ 
            ...prevData, 
            url: { 
                ...prevData.url, 
                [activeLang]: slugValue 
            }, 
            name: { 
                ...prevData.name, 
                [activeLang]: nameValue 
            } 
        }));
    }, [activeLang]);

    const save = async () => {
        setError(null);
        setSaving(true);

        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/menus',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                title: t('Saved successfully'),
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
            });
            
            reloaditem();
            let x = key + 1;
            setKey(x);
            setData({
                name: { ku: '', fa: '', en: '', ar: '', tr: '' },
                url: { ku: '', fa: '', en: '', ar: '', tr: '' },
                code: '',
                keywords: { ku: '', fa: '', en: '', ar: '', tr: '' },
                description: { ku: '', fa: '', en: '', ar: '', tr: '' },
                parent: null
            });
        } catch (error: any) {
            if (error.response?.data?.code === 11000 || error.response?.data?.code != null) {
                // Handle uniqueness error
                const urlValue = typeof data.url === 'object' 
                    ? (data.url?.[activeLang] || data.url?.en || data.url?.ku || data.url?.fa || data.url?.ar || data.url?.tr || '') 
                    : (data.url || '');
                const errorMessage = error.response?.data?.message || `"${urlValue}" ${t('slug is available')}`;
                Swal.fire({
                    title: errorMessage,
                    icon: 'error',
                });
            } else if (error.response?.data?.message) {
                // Handle other validation errors
                if (typeof error.response.data.message === 'string') {
                    Swal.fire({
                        title: error.response.data.message,
                        icon: 'error',
                    });
                } else {
                    setError(error.response.data.message.errors);
                }
            } else {
                Swal.fire({
                    title: t('Error saving menu'),
                    icon: 'error',
                });
            }
        } finally {
            setSaving(false);
        }
    }

    return (
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl shadow-lg p-6 text-white">
            <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                </div>
                <h4 className="text-xl font-bold">{t('New Menu')}</h4>
            </div>
            <div className="h-px bg-white/20 mb-6"></div>

            <form key={key} className="space-y-4">
                {/* Language Selector */}
                <div>
                    <label className="block text-sm font-medium text-white/90 mb-2">
                        {t('Language')}
                    </label>
                    <div className="flex gap-2 flex-wrap">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                type="button"
                                onClick={() => setActiveLang(lang.code)}
                                className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
                                    activeLang === lang.code
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-white/10 text-white/70 hover:bg-white/20'
                                }`}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-white/90 mb-2">
                        {t('Name')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <input
                        type="text"
                        value={data.name?.[activeLang] || ''}
                        className={`w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all ${
                            error != null && error['name'] != undefined ? 'border-red-500 bg-red-500/20' : ''
                        }`}
                        placeholder={t('Name')}
                        onChange={(e) => handleNameChange(e.target.value)}
                    />
                    {error != null && error['name'] != undefined && (
                        <p className="mt-1 text-sm text-red-300">{error['name']['message']}</p>
                    )}
                </div>
                
                <div>
                    <label className="block text-sm font-medium text-white/90 mb-2">
                        {t('Slug')} ({languages.find(l => l.code === activeLang)?.label})
                    </label>
                    <input
                        value={data.url?.[activeLang] || ''}
                        type="text"
                        className={`w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all font-mono text-sm ${
                            error != null && error['url'] != undefined ? 'border-red-500 bg-red-500/20' : ''
                        }`}
                        placeholder={t('Slug')}
                        onChange={(e) => setData({ 
                            ...data, 
                            url: { 
                                ...data.url, 
                                [activeLang]: e.target.value 
                            } 
                        })}
                    />
                    {error != null && error['url'] != undefined && (
                        <p className="mt-1 text-sm text-red-300">{error['url']['message']}</p>
                    )}
                </div>

                <div>
                    <label className="block text-sm font-medium text-white/90 mb-2">
                        {t('Code')} <span className="text-red-400">*</span>
                    </label>
                    <input
                        value={data.code || ''}
                        type="text"
                        className={`w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all font-mono text-sm ${
                            error != null && error['code'] != undefined ? 'border-red-500 bg-red-500/20' : ''
                        }`}
                        placeholder={t('Code')}
                        onChange={(e) => setData({ 
                            ...data, 
                            code: e.target.value 
                        })}
                    />
                    {error != null && error['code'] != undefined && (
                        <p className="mt-1 text-sm text-red-300">{error['code']['message']}</p>
                    )}
                    <p className="mt-1 text-xs text-white/60">
                        {t('Unique code for this menu (e.g., MENU001)')}
                    </p>
                </div>

                <button
                    type="button"
                    onClick={(e) => { save() }}
                    disabled={saving || !(data.name?.[activeLang]?.trim()) || !(data.code?.trim())}
                    className="w-full py-3 px-4 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
                >
                    {saving ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            {t('Saving...')}
                        </>
                    ) : (
                        t('Save')
                    )}
                </button>
            </form>
        </div>
    )
}
